import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";

import { Button, Box, CircularProgress, Paper, Table, TableBody, TableCell, TableContainer, TableFooter, TablePagination, TableRow, TextField } from "@material-ui/core";
import { Alert, Autocomplete } from "@material-ui/lab";

import { getError } from "../../utils/constants";
import axiosInstance from "../../utils/axios";

const rowsPerPage = 10;

function Agencies() {
  const [page, setPage] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [data, setData] = useState(undefined);
  const [error, setError] = useState(undefined);
  const history = useHistory();

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const res = await axiosInstance.get('/admin/agencies');
      setData(res.data);
    } catch (e) {
      console.error(e);
      setError({type: "error", open: true, message: getError(e)});
    } finally {
      setIsLoading(false);
    }
  }

  const handleChangePage = (_, newPage) => {
    setPage(newPage);
  };

  if (isLoading) {
    return (
      <CircularProgress />
    );
  }

  if (error) {
    return (
      <Alert severity={error.type}>
        {error.message}
      </Alert>
    );
  }

  return (<>
    <Box display="flex" justifyContent="space-between" mb={2}>
      <Button variant="contained" color="primary" to="/agency" component={Link}>Create New Agency</Button>
      <Box width="30%">
        <Autocomplete options={data} getOptionLabel={(o) => o.AgencyName} renderInput={(params) => <TextField {...params} label="Search" variant="outlined" size="small" />} onChange={(_, o) => history.push(`/agency/${o.ID}`)} />
      </Box>
    </Box>

    <TableContainer component={Paper}>
      <Table>
        <TableBody>
          {data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => (
            <TableRow hover={true} component={Link} to={`/agency/${row.ID}`} key={index}>
              <TableCell>
                {row.AgencyName}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              count={data.length}
              rowsPerPage={rowsPerPage}
              rowsPerPageOptions={[rowsPerPage]}
              page={page}
              onPageChange={handleChangePage}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  </>);
}

export default Agencies;
